<template>
    <div>
        <van-nav-bar title="我的话题" left-arrow @click-left="onClickLeft" />
        <div class="apply_btn" @click="applyForDiscuss">申请话题</div>
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <div class="my_discuss">
                <div class="discuss_rule">
                    <div class="btn" @click="gotodiscussrule">申请规则<span>?</span></div>
                </div>
                <topic-scroll url="com/discuss-list" :params="params" :text="'主人，没有更多啦~'" :text2="'暂无话题哦~'"
                    ref="discuss">
                    <template slot-scope="scope">
                        <div class="discuss-item" v-for="(row,i) in scope.data" :key="i">
                            <img class="left" :src="row.discuss_icon" alt="">
                            <div class="mid">
                                <div class="dn">{{ row.discuss_name }}</div>
                                <div class="dl">{{ row.discuss_lead }}</div>
                            </div>
                            <div class="right active" v-if="row.review_status == 0" @click="recallDiscuss(row.id)">
                                撤回
                            </div>
                            <div class="right active" v-else-if="row.review_status == 1" @click="openGame(row.id)">
                                进入话题
                            </div>
                            <div class="right active" v-else-if="row.review_status == 2" @click="deleteDiscuss(row.id)">
                                删除
                            </div>
                            <div class="right" v-else-if="row.review_status == 4">
                                已撤回
                            </div>
                        </div>
                    </template>
                </topic-scroll>
            </div>
        </van-pull-refresh>

    </div>
</template>

<script>
    import {
        Dialog
    } from "vant";
    import api from '../Api'
    export default {
        mixins: [api],
        data() {
            return {
                params: {
                    position: 'mine'
                }
            }
        },
        methods: {
            //前往话题申请规则
            gotodiscussrule() {

            },
            //申请话题
            applyForDiscuss() {
                var that = this
                this.$Ajax('com/whether-applic-discuss').then(rs => {
                    if (rs.code == 200) {
                        if (rs.data.flag) {
                            this.$RModal.applyDiscuss({
                                onSuccess: () => {
                                    that.$refs.discuss.refresh()
                                }
                            })
                        }

                    }
                })
            },
            //撤回话题
            recallDiscuss(id) {
                var that = this
                Dialog.confirm({
                        title: '',
                        message: '确定撤回该话题吗？',
                    })
                    .then(() => {
                        that.$Ajax('com/revoke-applic-discuss', {
                            discuss_id: id
                        }).then(rs => {
                            if (rs.code == 200) {
                                that.$refs.discuss.refresh()
                            }
                        })
                    })
                    .catch(() => {
                        // on cancel
                    });
            },
            //删除
            deleteDiscuss(id) {
                var that = this
                Dialog.confirm({
                        title: '',
                        message: '确定删除该话题吗？',
                    })
                    .then(() => {
                        that.$Ajax('com/delete-applic-discuss', {
                            discuss_id: id
                        }).then(rs => {
                            if (rs.code == 200) {
                                that.$refs.discuss.refresh()
                            }
                        })
                    })
                    .catch(() => {
                        // on cancel
                    });

            }
        },
    }
</script>

<style lang="less" sopced>
    .apply_btn {
        position: fixed;
        top: 0.65rem;
        right: 0.75rem;
        color: #670000;
        z-index: 100;
    }

    .my_discuss {
        margin-top: 2.5rem;
        padding: .6rem .75rem;

        .discuss_rule {
            margin-bottom: .6rem;
            padding-right: 0.5rem;
            display: flex;
            justify-content: flex-end;

            .btn {
                color: #670000;
                font-size: .6rem;
                display: flex;
                align-items: center;

                span {
                    width: .8rem;
                    height: .8rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: #670000;
                    color: #fff;
                    font-size: .6rem;
                    border-radius: 50%;
                    transform: scale(0.8);
                    margin-left: .1rem;
                }
            }
        }

        .discuss-item {
            display: flex;
            align-items: flex-start;
            padding: .4rem .6rem .75rem;
            margin-bottom: .6rem;
            border-radius: .6rem;
            background-color: #fff;

            .left {
                width: 2.65rem;
                height: auto;
                max-height: 4rem;
                border-radius: .4rem;
                margin-right: 14px;
            }

            .mid {
                flex: 1;

                .dn {
                    color: #000;
                    margin-bottom: .3rem;
                    font-weight: 700;
                }

                .dl {
                    word-break: break-all;
                    color: #656565;
                    font-size: .6rem;
                }
            }

            .right {
                margin-top: .65rem;
                margin-left: 1.7rem;
                width: 3.2rem;
                height: 1.4rem;
                line-height: 1.4rem;
                text-align: center;
                border-radius: 10rem;
                font-size: .6rem;
                background-color: #F3F2F2;
                color: #9e9e9e;

                &.active {
                    background-color: #ECD7D5;
                    color: #670000;
                }

                &:active {
                    opacity: 0.9;
                }
            }
        }
    }
</style>